export const UPLOAD_IMAGE_ACTION = 'UPLOAD_IMAGE_ACTION';
export const RESET_UPLOAD_IMAGE = 'RESET_UPLOAD_IMAGE';
export const RESET_CREATE_CONTENT = 'RESET_CREATE_CONTENT';
